import { getAccountImportExportSettingFormConfig } from './getAccountImportExportSettingFormConfig';
export const getAccountImportSettingFormConfig = (defaultAccountFieldTypeValues, settingDestinationFieldExclusions, settingLengthFieldInclusions, additionalWidgetConfigTypes) => {
    const destinationConfig = {
        type: 'form.text',
        key: 'destination',
        label: 'Destination',
        hidden: {
            when: '^^/type',
            dataIn: settingDestinationFieldExclusions !== null && settingDestinationFieldExclusions !== void 0 ? settingDestinationFieldExclusions : [],
        },
    };
    const additionalFields = [
        {
            type: 'form.text',
            key: 'exampleValue',
            label: 'Example Value',
        },
        {
            type: 'form.panel',
            children: [
                {
                    type: 'form.number',
                    key: 'length',
                    label: 'Field Length',
                    hidden: {
                        when: '^^/type',
                        dataNotIn: settingLengthFieldInclusions !== null && settingLengthFieldInclusions !== void 0 ? settingLengthFieldInclusions : [],
                    },
                },
                {
                    type: 'form.checkbox',
                    key: 'required',
                    label: 'Required',
                },
            ],
            style: {
                layout: 'row',
                horizontalAlign: 'left',
                verticalAlign: 'center',
            },
        },
        ...(additionalWidgetConfigTypes || []),
    ];
    return getAccountImportExportSettingFormConfig(defaultAccountFieldTypeValues, [destinationConfig], additionalFields, true);
};
